import ApiService from '@services/api.service'

const resource = 'chatbot'

export default {
    send(message, portal) {
        return ApiService.post(`/${resource}/send`, { message, portal })
    },

    history() {
        return ApiService.get(`/${resource}/history`)
    },

    clear() {
        return ApiService.delete(`/${resource}/clear`)
    },

    audioToText(formData) {
        return ApiService.post(`/${resource}/audio-to-text`, formData)
    },

    textToSpeech(text) {
        return ApiService.post(`/${resource}/text-to-speech`, { text }, { responseType: 'blob' })
    },

    ping() {
        return ApiService.post(`/${resource}/ping`)
    }
}
